import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAnimation } from 'hooks/useAnimation';
import { selectLocations } from 'store/slices/LocationsSlice';
import { ReactComponent as WorldMap } from 'assets/world-map.svg';
import MouseTracker from './MouseTracker';
import { useNavigate } from 'react-router-dom';

import './styles.scss';
import ROUTES from 'constants/routes';
import { getImageUrl } from 'helpers';
import MapListDropdown from './MaplistDropdown';
import useMediaQuery from 'hooks/useMediaQuery';

const LocationWorldMap = ({ isLoading }) => {
    const [selectedCountry, setSelectedCountry] = useState(null);
    const locations = useSelector(selectLocations);
    // const isLoading = useSelector(selectCurrentLocationIsLoading);
    const container = useRef();
    const map = useRef();
    const isTablet = useMediaQuery('max-width:768px')

    const navigate = useNavigate();
    const [hoveredData, setHoveredData] = useState(null);

    useAnimation({
        items: ['.location-map'],
        container,
        dependencies: [isLoading],
    });



    const handleCountryHover = (event) => {
        const target = event.target;

        if (target.tagName.toLowerCase() === 'svg') {
            setHoveredData(null);
            return;
        }

        const pathId = target.id;
        let hoveredElementId = pathId;

        if (!hoveredElementId && target.parentNode && target.parentNode.id) {
            hoveredElementId = target.parentNode.id;
        }

        const matchingData = locations.find(item => item.attributes.country_code.toLowerCase() === hoveredElementId);

        if (matchingData) {
            setHoveredData(matchingData);
        } else {
            setHoveredData(null);
        }
    };

    const handleCountryLeave = () => {
        setHoveredData(null);
    };

    const handleCountryClick = () => {

        if (hoveredData) {
            navigate(`${ROUTES.location}/${hoveredData.attributes.slug}`);
        }
    };
    const applyRedFillToElement = (elementId) => {
        if (elementId) {
            const lowerCaseElementId = elementId.toLowerCase();
            // @ts-ignore
            const element = map.current.querySelector(`#${lowerCaseElementId}`);
            // @ts-ignore
            const selectedElements = map.current.querySelectorAll('.selected');
            selectedElements.forEach(element => {
                element.classList.remove('selected');
            });

            if (element) {
                if (element.tagName.toLowerCase() === 'g') {
                    const paths = element.querySelectorAll('path');
                    paths.forEach(path => {
                        path.classList.add('available');
                    });
                } else if (element.tagName.toLowerCase() === 'path') {
                    element.classList.add('available');
                }
            }
        }
    };
    const applySelectedCountry = (elementId) => {
        if (elementId) {
            const lowerCaseElementId = elementId.toLowerCase();
            // @ts-ignore
            const element = map.current.querySelector(`#${lowerCaseElementId}`);

            if (element) {
                if (element.tagName.toLowerCase() === 'g') {
                    const paths = element.querySelectorAll('path');
                    paths.forEach(path => {
                        path.classList.add('selected');
                    });
                } else if (element.tagName.toLowerCase() === 'path') {
                    element.classList.add('selected');
                }
            }
        }
    };


    useEffect(() => {
        locations?.forEach(item => {
            applyRedFillToElement(item.attributes.country_code);
        });
        if (selectedCountry && isTablet) {
            applySelectedCountry(selectedCountry.attributes.country_code)
        }
    }, [locations, selectedCountry, isTablet]);
    if (!locations) return

    return (
        <section ref={container} className="container">
            {isTablet && <MapListDropdown selectedCountry={selectedCountry} setSelectedCountry={setSelectedCountry} countries={locations} />}
            <div className={`location-map ${hoveredData ? "location-map--find-element" : ""} `} onMouseMove={handleCountryHover} onMouseLeave={handleCountryLeave} onClick={handleCountryClick}>
                <WorldMap ref={map} />
            </div>
            {hoveredData && (
                <MouseTracker country={hoveredData.attributes.name} flag={getImageUrl(hoveredData.attributes.flag)} ips={hoveredData.attributes.hero.title} />
            )}

            {selectedCountry && isTablet &&
                <div className='location-map-selected-country'>
                    <img className="location-map-selected-country__flag" src={getImageUrl(selectedCountry.attributes.flag)} alt={selectedCountry.attributes.name} />
                    <div className=" location-map-selected-country__body">
                        <div className='tag-text'>{selectedCountry.attributes.name}</div>
                        <div className='body4'>{selectedCountry.attributes.hero.title}</div>
                    </div>
                </div>
            }

        </section>
    );
};

export default LocationWorldMap;
